import React, { FC, ReactElement } from 'react';
import { Icon } from '@whitesharx/starfall-frontend-ui-kit';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import classNames from 'classnames';
import { useAtom } from '@reatom/npm-react';
import {
  containerStyles,
  descriptionStyles,
  drawBackgroundStyles,
  loseBackgroundStyles,
  scoreStyles,
  titleTextStyles,
  winBackgroundStyles,
  contentStyles,
  iconStyles,
  iconAndScoreStyles,
  backgroundStyles,
  buttonsContainer,
  buttonsRowStyles,
  modalContentStyles,
  rowStyles,
  closeButtonStyles,
} from './styles.css';
import { gameResultAtom } from '../../model';
import { Modal, ModalCloseButton } from '../Modals/Modal';
import { GAME_MODE_ICONS, GameMode, GameResultTitle } from '../../constants';
import PlayerGeneralInfo from './PlayerGeneralInfo';

type Props = {
  mode: GameMode;
  buttons: ReactElement[];
  isDesktop: boolean;
};

export const GameResultModal: FC<Props> = ({ mode, buttons, isDesktop }) => {
  const [gameResult, setGameResult] = useAtom(gameResultAtom);

  if (!gameResult) {
    return null;
  }

  const { title, description, player, enemy } = gameResult;
  const isWin = title === GameResultTitle.victory;
  const isLose = title === GameResultTitle.defeat;

  return (
    <Modal.Chess isOpen contentClassName={modalContentStyles} maxWidth={406}>
      <div
        className={classNames(
          backgroundStyles,
          isWin ? winBackgroundStyles : isLose ? loseBackgroundStyles : drawBackgroundStyles
        )}
      />

      <ModalCloseButton className={closeButtonStyles} onClick={() => setGameResult(null)} />
      <div className={contentStyles}>
        <div className={titleTextStyles}>{t(`game-result.${title}`)}</div>
        {description && <div className={descriptionStyles}>{description}</div>}
        <div className={containerStyles}>
          <PlayerGeneralInfo {...player} isWin={isWin} setName={undefined} isDesktop={isDesktop} />
          <div className={iconAndScoreStyles}>
            {mode !== GameMode.GAMEWITHOUTTIMERS && <Icon name={GAME_MODE_ICONS[mode]} className={iconStyles} />}
            <p className={scoreStyles}>{`${Number(isWin)} - ${Number(isLose)}`}</p>
          </div>
          <PlayerGeneralInfo {...enemy} isWin={isLose} setName={undefined} isDesktop={isDesktop} />
        </div>
      </div>

      <div className={buttonsContainer}>
        <div className={classNames(buttonsRowStyles, rowStyles[1])}>
          {buttons.map((button, index) => React.cloneElement(button, { key: index }))}
        </div>
      </div>
    </Modal.Chess>
  );
};
